import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiTextInput } from '@splashthat/sui';

import { getFormNode } from 'common/entities/formNode/selectors';
import { updateFormNodeValue } from '../../../actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

const PLACEHOLDER_LABEL = 'Placeholder Text';
const INPUT_PLACEHOLDER = 'Enter Placeholder Value';
const BASE_COMPONENT_NAME = 'PlaceholderTextControl';

const PlaceholderTextControl = ({ value, onChange, disabled }) => (
    <SuiTextInput
        fullWidth
        label={PLACEHOLDER_LABEL}
        value={value}
        placeholder={INPUT_PLACEHOLDER}
        onChange={(event, newValue) => onChange(newValue)}
        disabled={disabled}
        data-qa={`${BASE_COMPONENT_NAME}__input`}
    />
);

PlaceholderTextControl.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

PlaceholderTextControl.defaultProps = {
    value: '',
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        value: props.formNodeId ? formNode.placeholder : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (placeholder) => dispatch(updateFormNodeValue(ownProps.formNodeId, 'placeholder', placeholder)),
});

const ConnectedPlaceholderTextControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(PlaceholderTextControl));

ConnectedPlaceholderTextControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedPlaceholderTextControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedPlaceholderTextControl;
